module.exports = __webpack_public_path__ + "img/daneshbonyan.a66bb77.svg";